export const shouldUseTypeBasedEntityApi = () => Boolean(globalThis.useTypeBasedApi && globalThis.productSuffix);

/**
 * Returns the path/query identifier for entity routes and type-based API calls.
 * Legacy mode uses entity.id; type-based mode uses entity.type (falls back to id when type is null).
 */
export const getEntityRouteParam = entity => {
  if (!entity) return undefined;
  if (shouldUseTypeBasedEntityApi() && entity.type != null) {
    return entity.type;
  }
  return entity.id;
};

/**
 * True when `ref` points at `entity` - either its numeric id (legacy) or its route param/type (type-based, where a
 * relationship field's related_entity_id holds the target's type).
 */
export const isEntityReference = (entity, ref) => {
  if (!entity || ref === undefined || ref === null) return false;
  return entity.id === ref || String(getEntityRouteParam(entity)) === String(ref);
};

/** Wraps getEntityRouteParam for service methods that expect `{ id }` (mapArgs renames to type in v2). */
export const getEntityServiceIds = entity => ({ id: getEntityRouteParam(entity) });

/** Route param from useParams is already the correct segment value for the active API mode. */
export const getEntityServiceIdsFromRouteParam = routeParam => ({ id: routeParam });

/** Display label for an entity: title-first when type-based API is active, name-first otherwise. */
export const getEntityDisplayLabel = entity => {
  if (!entity) return undefined;
  return shouldUseTypeBasedEntityApi() ? entity.title ?? entity.name : entity.name ?? entity.title;
};

/**
 * Id used to address a RELATIONSHIP field's target for choices search / field-resolutions.
 * A type-based native lookup stores the target's lego_id in related_entity_id, which is also
 * the host datasources `id` - so it is used directly. field_options.source_id is the host's
 * legacy id: persisted verbatim on save, never used for fetching.
 */
export const getRelationshipSourceId = field => {
  return field?.related_entity_id;
};

/**
 * Finds the associated record for a custom-object RELATIONSHIP value. The type-based API nests associations by the
 * target's type then display_id ({ [targetType]: { [displayId]: record } }); the legacy API keys them by display_id only.
 */
export const getAssociatedRecord = (associations, field, displayId) => {
  const targetKey = getRelationshipSourceId(field);
  return associations?.[targetKey]?.[displayId] ?? associations?.[displayId];
};
